import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { apiFetch } from 'utils/apiFetch'

export type NodeRemoveMeta = routes.ServiceCenterNodeRemove.Request

export const request = async (param: NodeRemoveMeta) => {
  await apiFetch({ url: '/service-center-node-remove', body: param })

  return param
}

export const callback = async (param: NodeRemoveMeta) => {
  serviceCenterStore.actions.removeActiveNodes([param.nodeIdentifier])
}

export const serviceCenterNodeRemove = {
  request,
  callback,
}
